import { Table } from "../../../../../_helpers/Table";
import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { getTeamEstablishments } from "../../../../../_api/Team";

export const TeamsTab = (props) => {
    const { currentApp, currentMenu, currentTab, user } = props;
    const features_right = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["COMPANY"]["features"];

    const navigate = useNavigate();
    const { establishment_id } = useParams();
    const [data, setData] = useState([]);

    const headers = ["Nom", "Niveau"];

    const loadTeams = async () => {
        await getTeamEstablishments(establishment_id).then((resp) => {
            setData(
                resp.data.map((res) => {
                    return {
                        row: [res.name, res.level],
                        data: res,
                    };
                }).sort(function (a, b) {
                    return a?.row[0] < b?.row[0] ? -1 : 1 }));
        });
    };
    const rowClick = (value) => {
        navigate(
            "/company/establishments/" +
            value.establishment_id +
            "/team/" +
            value.id
        );
    };

    useEffect(() => {
        loadTeams();
    }, [establishment_id]);

    return (
        <>
            <Table
                name={"Service[s]"}
                headers={headers}
                isVisible={features_right['add_service']}
                addNavigate={
                    "/company/establishments/" + establishment_id + "/team/new"
                }
                rows={data}
                onClick={rowClick}
            />
        </>
    );
};
